<template>
  <div class="base-timer">
    <svg class="base-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <g class="base-timer__circle">
        <circle class="base-timer__path-elapsed" cx="50" cy="50" r="45" />
        <path
          :stroke-dasharray="circleDasharray"
          class="base-timer__path-remaining"
          d="
            M 50, 50
            m -45, 0
            a 45,45 0 1,0 90,0
            a 45,45 0 1,0 -90,0
          "
        ></path>
      </g>
    </svg>
    <p class="base-timer__label">
      {{ value }} <br />
      <span class="base-timer__sublabel">{{ label }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "CountdownTimerRing",
  props: {
    value: Number,
    maxValue: Number,
    label: String
  },
  computed: {
    wholeCircleLength() {
      return (2 * Math.PI * 45).toFixed(0);
    },
    circleDasharray() {
      return `${((this.value / this.maxValue) * this.wholeCircleLength).toFixed(0)} ${this.wholeCircleLength}`;
    }
  }
};
</script>

<style lang="less">
@import "../../theme";
.base-timer {
  position: relative;
  height: 80px;
  width: 80px;
}
.base-timer__circle {
  fill: none;
  stroke: none;
}
.base-timer__path-elapsed {
  stroke-width: 5px;
  stroke: @gray-light;
}
.base-timer__label {
  position: absolute;
  width: inherit;
  height: inherit;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  color: @text-color;
}
.base-timer__sublabel {
  font-weight: normal;
  font-size: 12px;
}
.base-timer__path-remaining {
  stroke-width: 5px;
  stroke-linecap: round;
  transform: rotate(90deg);
  transform-origin: center;
  transition: 1s linear all;
  stroke: @color-primary;
}
.base-timer__svg {
  transform: scaleX(-1);
}
@media (max-width: 500px) {
  .base-timer {
    height: 70px;
    width: 70px;
  }
}
</style>
